import { useContext, useEffect, useState } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';
import { useIsC1Integrated } from '@/components/C1Integration/useIsC1Integrated';
import { GigyaContext } from '@/components/GigyaContext/GigyaLoader';


export function useIsLoggedIn() {
    const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);

    const isC1Integrated = useIsC1Integrated();
    const gigya = useContext(GigyaContext);

    useEffect(() => {
        if(isC1Integrated === null) {
            return; // Wait until isC1Integrated is loaded
        }
        if(! isC1Integrated) {
            fetchAuthSession().then(auth => setIsLoggedIn(auth.userSub !== undefined));
        } else {
            setIsLoggedIn(gigya?.hasSession ?? null);
        }
    }, [isC1Integrated, gigya]);

    return isLoggedIn;
}